import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"
import { CheckIcon, MinusIcon } from "lucide-react"
import { cn } from "@/primitives/utils"

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // beacon: a 16px box whose border is the subtle text tier, so the outline passes 3:1 on
        // every surface; checked or indeterminate it fills with the primary colour. A 2px focus
        // ring. The hit area reaches past the box, to 40×32 on a fine pointer and 44×44 on touch.
        "peer group/checkbox relative flex size-4 shrink-0 items-center justify-center rounded-sm border border-subtle-foreground bg-background text-primary-foreground transition-colors duration-100 ease-snappy outline-none group-has-disabled/field:opacity-50 group-has-[:focus-visible]/field-label:ring-0 after:absolute after:-inset-x-3 after:-inset-y-2 touch-target focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 data-checked:border-primary data-checked:bg-primary data-indeterminate:border-primary data-indeterminate:bg-primary dark:bg-surface-sunken dark:data-checked:bg-primary dark:data-indeterminate:bg-primary",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3 [&>svg]:stroke-3"
      >
        {/* beacon: a dash when indeterminate (some of a group chosen), a check when checked. */}
        <MinusIcon className="hidden group-data-[indeterminate]/checkbox:block" />
        <CheckIcon className="group-data-[indeterminate]/checkbox:hidden" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
